// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    align-items: center;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    background: linear-gradient(to bottom, #2ecc71, #ffffff);
}

.admin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);
    border: 1px solid rgba(46, 204, 113, 0.2);
    backdrop-filter: blur(5px);
}

.admin-header h1 {
    color: #2ecc71;
    font-size: 1.75rem;
    font-weight: 600;
    margin: 0;
}

.admin-content {
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
}

.admin-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);
    border: 1px solid rgba(46, 204, 113, 0.2);
    backdrop-filter: blur(5px);
}

.admin-controls h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2ecc71;
    margin: 0;
}

.admin-buttons {
    display: flex;
    gap: 10px;
}

.members-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 20px;
}

.member-item {
    background: rgba(0, 0, 0, 0.7);
    padding: 15px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(46, 204, 113, 0.2);
    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);
    backdrop-filter: blur(5px);
}

.member-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(46, 204, 113, 0.4);
    border-color: rgba(46, 204, 113, 0.4);
}

.member-item.selected {
    border-color: #2ecc71;
    background: rgba(46, 204, 113, 0.2);
}

.member-name {
    font-size: 1rem;
    color: #fff;
}

.error-message {
    color: #ffcccc;
    text-align: center;
    margin: 10px 0;
    padding: 15px;
    background: rgba(255, 0, 0, 0.2);
    border-radius: 8px;
    border-left: 4px solid #ff4444;
}

.kick-all-button,
.kick-button,
.add-random-button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    color: white;
}

.kick-all-button {
    background-color: #e74c3c;
}

.kick-all-button:hover:not(:disabled) {
    background-color: #c0392b;
    transform: translateY(-2px);
}

.kick-button {
    background-color: #2ecc71;
}

.kick-button:hover:not(:disabled) {
    background-color: #27ae60;
    transform: translateY(-2px);
}

.add-random-button {
    background-color: #27ae60;
}

.add-random-button:hover:not(:disabled) {
    background-color: #219a52;
    transform: translateY(-2px);
}

.kick-all-button:disabled,
.kick-button:disabled,
.add-random-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.65;
    transform: none;
}

.success-message {
    color: #fff;
    text-align: center;
    margin: 10px 0;
    padding: 15px;
    background: rgba(46, 204, 113, 0.2);
    border-radius: 8px;
    border-left: 4px solid #2ecc71;
    animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.server-status {
    font-size: 0.875rem;
    padding: 6px 12px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    color: #fff;
}

.server-status.checking {
    background-color: rgba(108, 117, 125, 0.3);
}

.server-status.online {
    background-color: rgba(46, 204, 113, 0.3);
}

.server-status.offline {
    background-color: rgba(231, 76, 60, 0.3);
}

.server-status.error {
    background-color: rgba(241, 196, 15, 0.3);
}

@media screen and (max-width: 768px) {
    .admin-content {
        padding: 10px;
    }

    .admin-header,
    .admin-controls {
        padding: 15px;
    }

    .admin-buttons {
        flex-wrap: wrap;
    }

    .members-list {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
}

@media screen and (max-width: 480px) {
    .admin-content {
        width: 95%;
    }

    .admin-header,
    .admin-controls {
        flex-direction: column;
        gap: 15px;
        text-align: center;
    }

    .admin-buttons {
        justify-content: center;
    }
}

.admin-section {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);
    border: 1px solid rgba(46, 204, 113, 0.2);
    backdrop-filter: blur(5px);
}

.admin-section h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2ecc71;
    margin: 0 0 15px 0;
}

.raffle-status {
    margin-bottom: 15px;
    font-size: 1.1em;
    color: #fff;
}

.raffle-status span {
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 4px;
}

.raffle-status span.active {
    background-color: rgba(46, 204, 113, 0.3);
    color: #2ecc71;
}

.raffle-status span.inactive {
    background-color: rgba(108, 117, 125, 0.3);
    color: #fff;
}

.start-raffle-button {
    background-color: #2ecc71;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    margin-right: 10px;
    transition: all 0.3s ease;
}

.start-raffle-button:hover:not(:disabled) {
    background-color: #27ae60;
    transform: translateY(-2px);
}

.start-raffle-button:disabled {
    background-color: rgba(108, 117, 125, 0.3);
    cursor: not-allowed;
    transform: none;
}

.end-raffle-button {
    background-color: #e74c3c;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    transition: all 0.3s ease;
}

.end-raffle-button:hover:not(:disabled) {
    background-color: #c0392b;
    transform: translateY(-2px);
}

.end-raffle-button:disabled {
    background-color: rgba(108, 117, 125, 0.3);
    cursor: not-allowed;
    transform: none;
}

.raffle-results {
    margin-top: 20px;
    padding: 15px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    border: 1px solid rgba(46, 204, 113, 0.2);
}

.raffle-results h3 {
    color: #2ecc71;
    margin: 0 0 15px 0;
    font-size: 1.1em;
}

.matches-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    margin-top: 15px;
}

.match-item {
    background: rgba(0, 0, 0, 0.7);
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);
    border: 1px solid rgba(46, 204, 113, 0.2);
    backdrop-filter: blur(5px);
    transition: all 0.3s ease;
}

.match-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(46, 204, 113, 0.4);
    border-color: rgba(46, 204, 113, 0.4);
}

.match-item h4 {
    margin: 0 0 10px 0;
    color: #2ecc71;
    font-size: 1em;
}

.match-item p {
    margin: 0;
    color: #fff;
    font-size: 0.9em;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,8CAA8C;IAC9C,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;;;IAGI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;;IAGI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,8BAA8B;IAC9B,oDAAoD;AACxD;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4DAA4D;IAChE;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;;QAEI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,8CAA8C;IAC9C,yCAAyC;IACzC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".admin-page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    background: linear-gradient(to bottom, #2ecc71, #ffffff);\n}\n\n.admin-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 800px;\n    margin: 20px auto;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);\n    border: 1px solid rgba(46, 204, 113, 0.2);\n    backdrop-filter: blur(5px);\n}\n\n.admin-header h1 {\n    color: #2ecc71;\n    font-size: 1.75rem;\n    font-weight: 600;\n    margin: 0;\n}\n\n.admin-content {\n    width: 90%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.admin-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);\n    border: 1px solid rgba(46, 204, 113, 0.2);\n    backdrop-filter: blur(5px);\n}\n\n.admin-controls h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #2ecc71;\n    margin: 0;\n}\n\n.admin-buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.members-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.member-item {\n    background: rgba(0, 0, 0, 0.7);\n    padding: 15px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: 1px solid rgba(46, 204, 113, 0.2);\n    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);\n    backdrop-filter: blur(5px);\n}\n\n.member-item:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(46, 204, 113, 0.4);\n    border-color: rgba(46, 204, 113, 0.4);\n}\n\n.member-item.selected {\n    border-color: #2ecc71;\n    background: rgba(46, 204, 113, 0.2);\n}\n\n.member-name {\n    font-size: 1rem;\n    color: #fff;\n}\n\n.error-message {\n    color: #ffcccc;\n    text-align: center;\n    margin: 10px 0;\n    padding: 15px;\n    background: rgba(255, 0, 0, 0.2);\n    border-radius: 8px;\n    border-left: 4px solid #ff4444;\n}\n\n.kick-all-button,\n.kick-button,\n.add-random-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    color: white;\n}\n\n.kick-all-button {\n    background-color: #e74c3c;\n}\n\n.kick-all-button:hover:not(:disabled) {\n    background-color: #c0392b;\n    transform: translateY(-2px);\n}\n\n.kick-button {\n    background-color: #2ecc71;\n}\n\n.kick-button:hover:not(:disabled) {\n    background-color: #27ae60;\n    transform: translateY(-2px);\n}\n\n.add-random-button {\n    background-color: #27ae60;\n}\n\n.add-random-button:hover:not(:disabled) {\n    background-color: #219a52;\n    transform: translateY(-2px);\n}\n\n.kick-all-button:disabled,\n.kick-button:disabled,\n.add-random-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    opacity: 0.65;\n    transform: none;\n}\n\n.success-message {\n    color: #fff;\n    text-align: center;\n    margin: 10px 0;\n    padding: 15px;\n    background: rgba(46, 204, 113, 0.2);\n    border-radius: 8px;\n    border-left: 4px solid #2ecc71;\n    animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.server-status {\n    font-size: 0.875rem;\n    padding: 6px 12px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    font-weight: 500;\n    color: #fff;\n}\n\n.server-status.checking {\n    background-color: rgba(108, 117, 125, 0.3);\n}\n\n.server-status.online {\n    background-color: rgba(46, 204, 113, 0.3);\n}\n\n.server-status.offline {\n    background-color: rgba(231, 76, 60, 0.3);\n}\n\n.server-status.error {\n    background-color: rgba(241, 196, 15, 0.3);\n}\n\n@media screen and (max-width: 768px) {\n    .admin-content {\n        padding: 10px;\n    }\n\n    .admin-header,\n    .admin-controls {\n        padding: 15px;\n    }\n\n    .admin-buttons {\n        flex-wrap: wrap;\n    }\n\n    .members-list {\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .admin-content {\n        width: 95%;\n    }\n\n    .admin-header,\n    .admin-controls {\n        flex-direction: column;\n        gap: 15px;\n        text-align: center;\n    }\n\n    .admin-buttons {\n        justify-content: center;\n    }\n}\n\n.admin-section {\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 20px;\n    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);\n    border: 1px solid rgba(46, 204, 113, 0.2);\n    backdrop-filter: blur(5px);\n}\n\n.admin-section h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #2ecc71;\n    margin: 0 0 15px 0;\n}\n\n.raffle-status {\n    margin-bottom: 15px;\n    font-size: 1.1em;\n    color: #fff;\n}\n\n.raffle-status span {\n    font-weight: bold;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n\n.raffle-status span.active {\n    background-color: rgba(46, 204, 113, 0.3);\n    color: #2ecc71;\n}\n\n.raffle-status span.inactive {\n    background-color: rgba(108, 117, 125, 0.3);\n    color: #fff;\n}\n\n.start-raffle-button {\n    background-color: #2ecc71;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1em;\n    margin-right: 10px;\n    transition: all 0.3s ease;\n}\n\n.start-raffle-button:hover:not(:disabled) {\n    background-color: #27ae60;\n    transform: translateY(-2px);\n}\n\n.start-raffle-button:disabled {\n    background-color: rgba(108, 117, 125, 0.3);\n    cursor: not-allowed;\n    transform: none;\n}\n\n.end-raffle-button {\n    background-color: #e74c3c;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1em;\n    transition: all 0.3s ease;\n}\n\n.end-raffle-button:hover:not(:disabled) {\n    background-color: #c0392b;\n    transform: translateY(-2px);\n}\n\n.end-raffle-button:disabled {\n    background-color: rgba(108, 117, 125, 0.3);\n    cursor: not-allowed;\n    transform: none;\n}\n\n.raffle-results {\n    margin-top: 20px;\n    padding: 15px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n    border: 1px solid rgba(46, 204, 113, 0.2);\n}\n\n.raffle-results h3 {\n    color: #2ecc71;\n    margin: 0 0 15px 0;\n    font-size: 1.1em;\n}\n\n.matches-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 15px;\n    margin-top: 15px;\n}\n\n.match-item {\n    background: rgba(0, 0, 0, 0.7);\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3);\n    border: 1px solid rgba(46, 204, 113, 0.2);\n    backdrop-filter: blur(5px);\n    transition: all 0.3s ease;\n}\n\n.match-item:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(46, 204, 113, 0.4);\n    border-color: rgba(46, 204, 113, 0.4);\n}\n\n.match-item h4 {\n    margin: 0 0 10px 0;\n    color: #2ecc71;\n    font-size: 1em;\n}\n\n.match-item p {\n    margin: 0;\n    color: #fff;\n    font-size: 0.9em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
